import axios from 'axios'
import { Message } from 'element-ui'

// API基础地址
export const API_BASE_URL = 'https://huashancloud.com.cn'
// export const API_BASE_URL = 'http://localhost:30000'
// export const API_BASE_URL = 'https://8.145.49.133'


// 创建axios实例
const service = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 如果是FormData（文件上传），不设置Content-Type，让浏览器自动设置
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码不是200，说明有错误
    if (res.code !== 200) {
      // 401未授权，清除token并跳转到登录页
      if (res.code === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('adminInfo')
        if (window.location.hash !== '#/login') {
          window.location.href = '/#/login'
        }
        return Promise.reject(new Error('未登录或Token已过期'))
      }
      
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理401错误
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('adminInfo')
      if (window.location.hash !== '#/login') {
        window.location.href = '/#/login'
      }
      return Promise.reject(new Error('未登录或Token已过期'))
    }
    
    Message({
      message: error.message || '网络错误',
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js